/**
 * Used for remembering the filtering of the connections list page
 */
import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const ConnectionFilterStorageKey = 'moxieConnectionFilter'
export const connectionFilterAtom = atomWithStorage<
    Record<
        string,
        {
            filterText: string
            includeDeleted: boolean
        }
    >
>(ConnectionFilterStorageKey, {}, undefined, {
    getOnInit: true,
})

export const useConnectionFilter = (marketCode: string) => {
    const [connectionFilter] = useAtom(connectionFilterAtom)
    return connectionFilter[marketCode] || { filterText: '', includeDeleted: false }
}

export const useSetConnectionFilterText = (marketCode: string) => {
    const [connectionFilter, setConnectionFilter] = useAtom(connectionFilterAtom)
    return (filterText: string) =>
        setConnectionFilter({
            ...connectionFilter,
            [marketCode]: { ...connectionFilter[marketCode], filterText },
        })
}

export const useSetConnectionFilterIncludeDeleted = (marketCode: string) => {
    const [connectionFilter, setConnectionFilter] = useAtom(connectionFilterAtom)
    return (includeDeleted: boolean) =>
        setConnectionFilter({
            ...connectionFilter,
            [marketCode]: { ...connectionFilter[marketCode], includeDeleted },
        })
}
